import { useState, useEffect } from 'react';
import {
    resolveMediaUrlsInHtml,
    collectMediaSrcUrls,
    needsMediaUrlRefresh,
} from './resolveMediaUrlsInHtml.js';

/**
 * Resolve embedded storage URLs in HTML without re-rendering when tokens are still valid.
 */
export function useResolvedMediaHtml(html) {
    const [resolved, setResolved] = useState(html || '');

    useEffect(() => {
        let cancelled = false;
        const incoming = html || '';

        if (!collectMediaSrcUrls(incoming).length || !needsMediaUrlRefresh(incoming)) {
            setResolved((prev) => (prev === incoming ? prev : incoming));
            return () => { cancelled = true; };
        }

        setResolved((prev) => (prev === incoming ? prev : incoming));
        resolveMediaUrlsInHtml(incoming).then((next) => {
            if (!cancelled && next !== incoming) setResolved(next);
        }).catch(() => {
            if (!cancelled) setResolved(incoming);
        });

        return () => { cancelled = true; };
    }, [html]);

    return resolved;
}
